import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Enums from 'Constants/Enums';
import './ExistingCustomerVettingStyle.less';

import TranslationUtils from 'Utils/TranslationUtils';

import { getUsecaseCategoryOptions, getUsecaseCategoryById } from '../../../Utils/GenericUtils';

const formScheme = {
  firstName: {
    initial: '',
    required: true,
    validate: (value) => {
      if (value.length > 30) {
        return TranslationUtils.getText('ERROR_TOO_LONG_30_CHARS');
      }

      return '';
    },
  },
  lastName: {
    initial: '',
    required: true,
    validate: (value) => {
      if (value.length > 30) {
        return TranslationUtils.getText('ERROR_TOO_LONG_30_CHARS');
      }

      return '';
    },
  },
  company: {
    initial: '',
    required: true,
    validate: (value) => {
      if (value.length > 255) {
        return TranslationUtils.getText('ERROR_TOO_LONG_255_CHARS');
      }

      return '';
    },
  },
  phone: {
    initial: '',
    required: true,
    validate: (value) => {
      if (value.length > 255) {
        return TranslationUtils.getText('ERROR_TOO_LONG_255_CHARS');
      }

      return '';
    },
  },
  country: {
    initial: '',
    required: true,
    validate: (value) => {
      if (value.length > 255) {
        return TranslationUtils.getText('ERROR_TOO_LONG_255_CHARS');
      }

      return '';
    },
  },

  seatsNumber: {
    initial: '1',
    required: false,
  },
  usecaseCategory: {
    initial: '',
    required: true,
  },
  usecaseSubCategory: {
    initial: '',
    required: false,
  },
  customUsecase: {
    initial: '',
    required: false,
    validate: (value) => {
      if (value.length > 255) {
        return TranslationUtils.getText('ERROR_TOO_LONG_255_CHARS');
      }

      return '';
    },
  },
  agreeToTerms: {
    initial: false,
    required: true,
    validate: (value) => {
      if (!(document.cookie.indexOf('automation_tests') > -1) && !value) {
        return TranslationUtils.getText('ERROR_REQUIRED_FIELD');
      }

      return '';
    },
  },
};

class LeadVettingPopup extends Component {
  state = {};

  validateUsecaseSubCategory = (categoryValue, subCategoryValue) => {
    const hasSubCategoryItems = getUsecaseCategoryOptions(categoryValue).length > 0;

    return !hasSubCategoryItems || (hasSubCategoryItems && subCategoryValue);
  };

  render() {
    return (
      <Formik
        validateOnBlur
        initialValues={Object.keys(formScheme).reduce((acc, key) => {
          acc[key] = formScheme[key].initial;
          return acc;
        }, {})}
        validate={(values) => {
          const errors = Object.keys(formScheme).reduce((acc, key) => {
            if (formScheme[key].validate && formScheme[key].validate(values[key])) {
              acc[key] = formScheme[key].validate(values[key]);
            }

            if (formScheme[key].required && (values[key] === '' || values[key] === null)) {
              acc[key] = TranslationUtils.getText('ERROR_REQUIRED_FIELD');
            }

            return acc;
          }, {});

          if (!this.validateUsecaseSubCategory(values.usecaseCategory, values.usecaseSubCategory)) {
            errors.usecaseSubCategory = TranslationUtils.getText('ERROR_REQUIRED_FIELD');
          }

          if (
            this.props.product === Enums.PRODUCT_TYPE.SEARCH_PURCHASE ||
            this.props.product === Enums.PRODUCT_TYPE.SEARCH_TRIAL
          ) {
            // if (values.seatsNumber.length === 0 && values.seatsNumber !== 0) {
            //   errors.seatsNumber = TranslationUtils.getText('ERROR_REQUIRED_FIELD');
            // }
            //
            // if (!Number.isNaN(values.seatsNumber) && parseInt(values.seatsNumber, 10) <= 0) {
            //   errors.seatsNumber = TranslationUtils.getText('ERROR_SEATS_NUMBER_MUST_BE_GREATER_THAN_ZERO');
            // }
            //
            // if (parseInt(values.seatsNumber, 10) < 1 || parseInt(values.seatsNumber, 10) > 100001) {
            //   errors.seatsNumber = TranslationUtils.getText('ERROR_INVALID_SEATS_NUMBER');
            // }
            // if (
            //   !Number.isNaN(values.seatsNumber) &&
            //   parseInt(values.seatsNumber, 10) > AppConfig.VETTING_SIGNUP_MAX_NUM_OF_SEATS
            // ) {
            //   errors.seatsNumber = TranslationUtils.getText('ERROR_SEATS_NUMBER_GREATER_THEN_TWENTY');
            // }
          }

          if (values.usecaseCategory && getUsecaseCategoryById(values.usecaseCategory).code === 'OTHER') {
            if (!values.customUsecase) {
              errors.customUsecase = TranslationUtils.getText('ERROR_REQUIRED_FIELD');
            }
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          const data = {
            ...values,
          };

          const trimmedData = Object.keys(data).reduce((acc, k) => {
            if (data[k]?.trim) {
              acc[k] = data[k].trim();
            } else {
              acc[k] = data[k];
            }

            return acc;
          }, {});

          this.props.onSubmit(trimmedData);
        }}
      >
        {(formProps) => {
          return this.props.children(formProps);
        }}
      </Formik>
    );
  }
}

export default LeadVettingPopup;

LeadVettingPopup.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.func.isRequired,
  product: PropTypes.string,
};
